import request from '@/utils/request'


// 查询回复消息列表
export function queryByPage(query) {
  return request({
    url: '/cnpReply/list',
    method: 'get',
    params: query
  })
}

//根据id查看回复详情
export function queryById(id) {
  return request({
    url: '/cnpReply/' + id,
    method: 'get',
  })
}

// 新增回复消息（供应商）
export function addNew(data) {
  return request({
    url: '/cnpReply/add',
    method: 'post',
    data: data
  })
}


// 逻辑删除资质
export function deleteByIds(id) {
  return request({
    url: '/cnpReply/' + id,
    method: 'delete'
  })
}

// 编辑资质
export function updateById(id,data) {
  return request({
    url: '/cnpReply/' + id,
    method: 'put',
    data: data
  })
}

export function countByStatus(categoryIds,userIds,fromUserId) {
  return request({
    url: '/cnpReply/'+categoryIds+'/'+fromUserId+'/'+userIds,
    method: 'get',
  })
}
/*url: `/cnpReply?categoryIds=${categoryIds}&userIds=${userIds}&fromUserId=${fromUserId}`,*/

















// WEBPACK FOOTER //
// ./src/api/words/reply.js